<template>
  <CommonModal>
    <!-- modalWidth="400px" -->
    <template slot="header">
      <h3>Change Order</h3>
    </template>
    <template slot="body">
      <!-- <table>
        <tbody>
          <draggable v-model="form.doctypeList">
          <td v-for="item in form.doctypeList" :key="item.doctypeId" class="order-box">
            {{ item.doctypeName }}
          </td>
        </draggable>
        </tbody>
      </table> -->
      <div @click="sortModel" id="modelList" class="arrow">
        Sort
      </div>
      <draggable  v-model="form.modelcodeList">
        <div v-for="item in form.modelcodeList" :key="item.modelcodeId" class="order-box">
          {{ item.modelcodeName }}
        </div>
      </draggable>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import $ from "jquery";
import {getModelCodeList, updateModelCodeOrder} from "@/api/modelcode";
import draggable from 'vuedraggable'
import CommonModal from "@/components/modal/CommonModal";

export default {
  components: {
    CommonModal ,
    draggable
  },
  data() {
    return {
      form : {
        modelcodeList: [],
      },
    };
  },
  methods: {
    async fetchData(lang){
      try {
        const response = await getModelCodeList(lang);
        this.form.modelcodeList = response.data.list;
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      await this.form.modelcodeList.forEach(function (item, index) {
        item.modelcodeSort = index;
      });
      await updateModelCodeOrder(this.form);
    },
    sortModel(){
      let tmp = this.form.modelcodeList;
      // tmp.sort();
      //modelcodeName
      let sortdir = 1;
      if($("#modelList").is(".up")){
        $("#modelList").removeClass("up");
        $("#modelList").addClass("down")
        sortdir = -1;
      }else{
        $("#modelList").addClass("up");
        $("#modelList").removeClass("down")
        sortdir = 1;
      }
      tmp.sort((a, b) => {
        let x = a.modelcodeName.toUpperCase();
        let y = b.modelcodeName.toUpperCase();
        return (x < y)?-sortdir:(x>y)?sortdir:0;
      });
      this.form.modelcodeList = tmp;

      console.log("ddd");
    }
  }
}
</script>

<style>

.arrow{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    border-bottom: 1px solid #e0e0e0;
}

.arrow:hover{
  cursor: pointer;
}

.up{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    background: url(../../img/background/fillter_arr_up.png) no-repeat right 50%;
}

.down{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    background: url(../../img/background/fillter_arr_down.png) no-repeat right 50%;
}
</style>